<template>
  <div>
    <el-form-item label="银行名称" prop="card_type">
      <el-select
        v-model="form.card_type"
        placeholder="请选择银行名称"
        style="width: 100%"
        filterable
        :loading="bankLoading"
        @change="handleBankNameChange"
      >
        <el-option v-for="opt in bankOptions" :key="opt.label" :label="opt.label" :value="opt.label"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="卡号" prop="card_no">
      <el-input v-model.trim="form.card_no" placeholder="请输入卡号" clearable maxlength="64" show-word-limit></el-input>
    </el-form-item>
  </div>
</template>

<script>
import { getBankNameMap } from '@/api/member/account'

export default {
  name: 'BankAccountFormFieldsNg',
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      bankLoading: false,
      bankOptions: [],
    }
  },
  methods: {
    async loadBankOptions() {
      if (this.bankLoading) return
      this.bankLoading = true
      try {
        const res = await getBankNameMap({})
        const raw = (res && res?.data?.bank_list) || {}
        const obj = raw && typeof raw === 'object' && !Array.isArray(raw) ? raw : {}
        const arr = Object.keys(obj).map(k => ({ label: k, value: obj[k] }))
        arr.sort((a, b) => a.label.localeCompare(b.label))
        this.bankOptions = arr
        this.handleBankNameChange(this.form.card_type)
      } catch (e) {
        this.bankOptions = []
        console.error(e)
      } finally {
        this.bankLoading = false
      }
    },
    handleBankNameChange(name) {
      const label = typeof name === 'string' ? name : this.form.card_type
      const opt = (this.bankOptions || []).find(o => o.label === label)
      this.form.extra1 = opt ? String(opt.value) : ''
    },
  },
}
</script>
